import { createFileRoute } from "@tanstack/react-router";

import TodosExported from "@/features/todos/todos-exported";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/ausgang/exported",
)({
  component: ReceivableExportedPage,
  staticData: {
    breadcrumb: ["todos.receivable.title"],
  },
});

function ReceivableExportedPage() {
  return <TodosExported type="receivable" />;
}
